import Player, { Controller } from "griffith";
import { useEffect, useState, useRef } from "react";
import { getVideoCategory, getVideoPlay } from "@/api/videoPlay";
import { Tree } from "antd";
import { cloneDeep } from "lodash-es";
import "./index.less";
import { useLocation } from "react-router-dom";
import { useGetLoginInfo } from "@/hooks/useGetLoginInfo";
import LoginAlertModal from "../loginAlertModal";
const sourcesData = {
  hd: {
    play_url: "",
  },
  sd: {
    play_url: "",
  },
};

const videoDetail = (props: any) => {
  const {
    url = "",
    close = () => {
      console.log(12);
    },
    needLoginTime=30,
  } = props;
  console.log("cur pay url =>", url);
  const [categoryFour, setCategoryFour] = useState<any>([]);
  const [sources, setSources] = useState(sourcesData);
  const [expandedKeys, setExpandedKeys] = useState<any>([]);
  const [currentKey, setCurrentKey] = useState<any>("");
  const currentPlayTime=useRef<any>(null);
  const timeout=useRef<any>(null);
  const videoRef = useRef<any>(null);
  const location = useLocation();
  const { authorization, portalAuthorization, goLogin } = useGetLoginInfo();
  const [showLoginAlertModal, setShowLoginAlertModal] = useState<boolean>(false);
  //获取视频数据
  const getVideoDataMenu = (child: any) => {
    const arr3: any = [];
    child.forEach((c: any, index: number) => {
      arr3.push({ ...c, goodsName: c.name });
    });
    if (arr3.length) {
      setCategoryFour(arr3);
      setSources({
        hd: {
          play_url: arr3[0]?.videoList?.[0].goodsVideo || "",
        },
        sd: {
          play_url: arr3[0]?.videoList?.[0].goodsVideo || "",
        },
      });
    }
  };

  //切换视频数据
  const handleClick = (item: any) => {
    if (item) {
      setSources({
        hd: {
          play_url: item.goodsVideo,
        },
        sd: {
          play_url: item.goodsVideo,
        },
      });
      //播放视频
      // videoRef.current.addEventListener("loadedmetadata", () => {
      //   videoRef.current.play();
      // });
    }
  };
const toggleFullScreen=()=> {
    const dom:any=document
      if(dom?.exitFullScreen) {
        dom.exitFullScreen();
              //兼容Firefox
        } else if(dom.mozCancelFullScreen) {
          dom.mozCancelFullScreen();
              //兼容Chrome, Safari and Opera等
        } else if(dom.webkitExitFullscreen) {
          dom.webkitExitFullscreen();
              //兼容IE/Edge
        } else if(dom.msExitFullscreen) {
          dom.msExitFullscreen();
         }
    }
  // 展开/收起节点
  const handleExpand = (expandedKeys: any) => {
    setExpandedKeys(expandedKeys);
  };

  const onSelect = (selectedKeys: any, info: any) => {
    // 获取当前节点的key
    const key: any = selectedKeys[0] || currentKey;
    setCurrentKey(key);
    // 判断节点是否已经展开
    const isExpanded = expandedKeys.includes(key);
    // 更新展开的节点keys
    setExpandedKeys(isExpanded ? expandedKeys.filter((k: any) => k !== key) : [...expandedKeys, key]);
    //切换视频
    if (info?.selectedNodes && !info?.selectedNodes?.[0]?.children) {
      handleClick(info.selectedNodes[0]);
    }
  };

  useEffect(() => {
    const id = location.pathname.slice(location.pathname.lastIndexOf("/") + 1);
    if (location?.state || id) {
      //   getVideoCategory(location?.state?.id || id).then((res: any) => {
      //     if (res?.code == 200) {
      //       if (res?.result?.length && res?.result?.[0]?.videoList) {
      //         getVideoDataMenu(res?.result);
      //       } else if (res?.result?.length) {
      //         setCategoryFour(res?.result);
      //         setSources({
      //           hd: {
      //             play_url: res?.result[0]?.goodsVideo || "",
      //           },
      //           sd: {
      //             play_url: res?.result[0]?.goodsVideo || "",
      //           },
      //         });
      //       }
      //     }
      //   });
    }
  }, []);
  const handlePlay = (e:any) => {
    console.log('video play',e);
    checkTimeStatus(currentPlayTime.current);
  }
  const handleTimeUpdate=(e:any)=>{
    console.log('video timeupdate',e.target.currentTime,authorization,portalAuthorization);
    checkTimeStatus(e.target.currentTime);
    currentPlayTime.current=e.target.currentTime;
  }
  const checkTimeStatus = (currentTime:any) => {
      if (timeout.current) clearTimeout(timeout.current);
      timeout.current = setTimeout(() => {
        if(currentTime>=needLoginTime && !(authorization )){
          videoRef.current.pause();
          setShowLoginAlertModal(true);
          if(document.fullscreenElement){
            toggleFullScreen();
          }
        }
      }, 200);
    };
  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.oncontextmenu = function () {
        return false;
      };
    }
  }, [videoRef.current]);

  return (
    <div className="video-play-detail-wrap">
      {showLoginAlertModal && <LoginAlertModal onClose={() => setShowLoginAlertModal(false)} onOk={() => goLogin()} />}
      <div className="video-play-detail-left">
        {/* <Player autoplay sources={sources} id={"1"} /> */}
        <div className="close-btn" onClick={close}>
          <s></s>
        </div>
        <video 
          id="video-play" 
          className="video-play-left" 
          controlsList="nodownload" 
          style={{ objectFit: "fill", position: "static" }} 
          ref={videoRef} src={url} 
          autoPlay 
          controls
          onPlay={handlePlay}
          onTimeUpdate={handleTimeUpdate}

        ></video>
      </div>
      {/* <div className="video-play-detail-right">
        <Tree
          blockNode
          treeData={categoryFour}
          expandedKeys={expandedKeys}
          onExpand={handleExpand}
          onSelect={onSelect}
          fieldNames={
        ></video>
      </div>
      {/* <div className="video-play-detail-right">
        <Tree
          blockNode
          treeData={categoryFour}
          expandedKeys={expandedKeys}
          onExpand={handleExpand}
          onSelect={onSelect}
          fieldNames={{ title: "goodsName", key: "id", children: "videoList" }}
        />
      </div> */}
    </div>
  );
};

export default videoDetail;
